module.exports = __webpack_public_path__ + "static/login-2dfd5739d90619dd27b60867048c40a5.mp3";